import { render, staticRenderFns } from "./PriceTable.vue?vue&type=template&id=e91c7aee&scoped=true&"
import script from "./PriceTable.vue?vue&type=script&lang=js&"
export * from "./PriceTable.vue?vue&type=script&lang=js&"
import style0 from "./PriceTable.vue?vue&type=style&index=0&id=e91c7aee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e91c7aee",
  null
  
)

export default component.exports